export function Brand({ light = false }: { light?: boolean }) {
  return <img
    className="brand-mark"
    src={light ? '/logo/logo-purple-bg.svg' : '/logo/logo-light-bg.svg'}
    alt="Música Com Você"
  />
}
